import '@site/styles/sass/styles.scss';
import $ from 'jquery';
import 'jquery-migrate';
import './vendor/niceSelect.js';
import './vendor/swishCarousel.js';
import './vendor/underscore-umd-min.js';
import './plugins.js';

window.$ = window.jQuery = $;

$(document).ready(function(){
	var _window = $(window);
	var today = new Date();
	
	// ---
	// Nav
	// ---
	$('nav')
	.each(function(){
		// Using an each loop means that each menu is independent
		var _nav = $(this);
		var _links = _nav.find('a');
		var match = _links.filter('[href="' + location.pathname.slice(1) + '"]:first');
		
		if (match.length > 0)
			match.addClass('active-lnk').parent('li').addClass('active active-li').parents('li').addClass('active');			
	});
	
	// Navigate when nav select is changed (for mobile)
	$('.nav-select').on('change', 'select', function(){
		window.location = $(this).val();
	});

	// Automatically set links with a different domain to open in a new window
	$('[href^=http]').each(function(){
		var _link = $(this);
		var href = _link.attr('href');

		if(href.indexOf(window.location.hostname) < 0)
			_link.attr('target', '_blank');

	});
	
	
	// -----------
	// Nice Select
	// -----------
	$('.nice-select-selector').niceSelect();


	// ---------
	// Carousels
	// ---------
	$('.banner .carousel')
		.swishCarousel({ animation: 'fade' });
	
	// --------------
	// External Links
	// --------------
	$('[rel=external]').attr('target', '_blank');
	
	
	// ---------
	// Polyfills
	// ---------
	if(!Modernizr.input.placeholder)
	{
		// Input placeholder text
		
		
		// Placeholder Function
		function placeholderFunc(){
			var _input = $(this);
			var _wrap = _input.parent('label');

			if (_wrap.length > 0) { // If there is a label you can use for the placeholder
				var classname = _input.attr('type') === 'date' ? 'show-date' : 'show';

				function updatePlaceholder() {
					if (_input.val() === '')
						_wrap.addClass(classname);
					else
						_wrap.removeClass(classname);
				}

				_input.on('focus blur keydown keyup', updatePlaceholder);

				updatePlaceholder(); // Test for existing values
			} else {
				var ph = _input.attr('placeholder');

				_input.on({
					focus: function(){
						if (_input.val() == ph)
							_input.val('').removeClass('placeholder-replacement');
					},
					blur: function(){
						if (_input.val() == "")
							_input.val(ph).addClass('placeholder-replacement');
					}
				}).blur();
			}
		}
	} // End if(!Modernizr.input.placeholder)

	// -----
	// Dates
	// -----
	$('.print-year').text(today.getFullYear());


	// -----------
	// Site Custom
	// -----------
	var _header = $('#header-site');
	var _footer = $('#footer-wrap');
	var _scrollContainer = $('.scroll-container');
	var _scrollContainerInner = $('.scroll-container-inner');
	var midPaddingMargin = 23; // The amount of padding / margin on the mid section

	/*console.log(_window.height());
	console.log(_header.outerHeight(true));
	console.log(_footer.outerHeight(true));*/

	function calculateSize(){
		var h = _window.height() - (_header.outerHeight(true) + _footer.outerHeight(true) + midPaddingMargin);
		var min = 260;
		h = h > min ? h : min;
		return h;
	}

	_scrollContainer.height(calculateSize());
	_scrollContainerInner.css({
		minHeight: calculateSize() + 1
	})

	_window.on('resize', function(){
		_scrollContainer.height(calculateSize());		
	});

	$('.scroll-container').scrollbarPaper();
});